// Export the tour steps for Rewards Landing page
export const rewardsLandingGuideSteps = [
  {
    element: "#RL-current-status-card",
    popover: {
      title: `<div class="flex items-center gap-3 mb-3">
            <div class="w-8 h-8 bg-brand-100 rounded-full flex items-center justify-center">
              <svg class="w-4 h-4 text-brand-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z"></path>
              </svg>
            </div>
            <span class="text-base font-semibold text-foreground">Current Rewards Status</span>
          </div>`,
      description: `<div class="space-y-3">
          <p class="text-sm text-muted-foreground">This card displays your current reward tier status, showing your achievement level and progress towards the next milestone.</p>
          <div class="bg-brand-50 p-3 rounded-lg">
            <ul class="text-xs text-brand-800 space-y-1">
              <li>• View your current tier and total revenue generated</li>
              <li>• Track your progress with the visual progress bar</li>
              <li>• See how much more you need to reach the next level</li>
              <li>• Read achievement messages and reward details</li>
            </ul>
          </div>
        </div>`,
      side: "right" as const,
      align: "start" as const,
    },
  },
  {
    element: "#RL-progress-bar",
    popover: {
      title: `<div class="flex items-center gap-3 mb-3">
            <div class="w-8 h-8 bg-brand-100 rounded-full flex items-center justify-center">
              <svg class="w-4 h-4 text-brand-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"></path>
              </svg>
            </div>
            <span class="text-base font-semibold text-foreground">Progress Tracker</span>
          </div>`,
      description: `<div class="space-y-3">
          <p class="text-sm text-muted-foreground">Your progress bar shows exactly how far you've come and how close you are to unlocking your next reward tier.</p>
          <div class="bg-brand-50 p-3 rounded-lg">
            <ul class="text-xs text-brand-800 space-y-1">
              <li>• Filled portion shows current progress</li>
              <li>• Left amount displays revenue generated so far</li>
              <li>• Right amount shows remaining revenue needed</li>
              <li>• Updates in real-time as you earn more</li>
            </ul>
          </div>
        </div>`,
      side: "bottom" as const,
      align: "center" as const,
    },
  },
  {
    element: "#RL-share-button",
    popover: {
      title: `<div class="flex items-center gap-3 mb-3">
            <div class="w-8 h-8 bg-brand-100 rounded-full flex items-center justify-center">
              <svg class="w-4 h-4 text-brand-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z"></path>
              </svg>
            </div>
            <span class="text-base font-semibold text-foreground">Share Your Progress</span>
          </div>`,
      description: `<div class="space-y-3">
          <p class="text-sm text-muted-foreground">Share your achievements with others! Generate a public link to showcase your reward milestones and progress.</p>
          <div class="bg-brand-50 p-3 rounded-lg">
            <ul class="text-xs text-brand-800 space-y-1">
              <li>• Creates a shareable public profile link</li>
              <li>• Link automatically copied to your clipboard</li>
              <li>• Shows your current tier and achievements</li>
              <li>• Perfect for social media or your portfolio</li>
              <li>• Motivates others and showcases your success</li>
            </ul>
          </div>
        </div>`,
      side: "top" as const,
      align: "center" as const,
    },
  },
  {
    element: "#RL-leaderboard-section",
    popover: {
      title: `<div class="flex items-center gap-3 mb-3">
            <div class="w-8 h-8 bg-brand-100 rounded-full flex items-center justify-center">
              <svg class="w-4 h-4 text-brand-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
              </svg>
            </div>
            <span class="text-base font-semibold text-foreground">ReveShare Leaderboard</span>
          </div>`,
      description: `<div class="space-y-3">
          <p class="text-sm text-muted-foreground">See the top earners on ReveShare and get inspired by their success. The leaderboard highlights achievement and visibility.</p>
          <div class="bg-brand-50 p-3 rounded-lg">
            <ul class="text-xs text-brand-800 space-y-1">
              <li>• View top performers and their earnings</li>
              <li>• See what tier levels they've achieved</li>
              <li>• Higher rankings = more visibility to brands</li>
              <li>• Get motivated to climb the ranks</li>
              <li>• Hard work pays off!</li>
            </ul>
          </div>
        </div>`,
      side: "left" as const,
      align: "start" as const,
    },
  },
  {
    element: "#RL-stats-cards",
    popover: {
      title: `<div class="flex items-center gap-3 mb-3">
            <div class="w-8 h-8 bg-brand-100 rounded-full flex items-center justify-center">
              <svg class="w-4 h-4 text-brand-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"></path>
              </svg>
            </div>
            <span class="text-base font-semibold text-foreground">Quick Stats Overview</span>
          </div>`,
      description: `<div class="space-y-3">
          <p class="text-sm text-muted-foreground">Get a quick snapshot of your key reward metrics at a glance. These cards provide essential information about your journey.</p>
          <div class="bg-brand-50 p-3 rounded-lg">
            <ul class="text-xs text-brand-800 space-y-1">
              <li>• <strong>Milestones Unlocked:</strong> Number of users who achieved your current tier</li>
              <li>• <strong>Current Tier:</strong> Your current reward level</li>
              <li>• <strong>To Next Tier:</strong> Amount needed for next milestone</li>
            </ul>
          </div>
        </div>`,
      side: "top" as const,
      align: "center" as const,
    },
  },
  {
    element: "#RL-milestone-sidebar",
    popover: {
      title: `<div class="flex items-center gap-3 mb-3">
            <div class="w-8 h-8 bg-brand-100 rounded-full flex items-center justify-center">
              <svg class="w-4 h-4 text-brand-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v13m0-13V6a2 2 0 112 2h-2zm0 0V5.5A2.5 2.5 0 109.5 8H12zm-7 4h14M5 12a2 2 0 110-4h14a2 2 0 110 4M5 12v7a2 2 0 002 2h10a2 2 0 002-2v-7"></path>
              </svg>
            </div>
            <span class="text-base font-semibold text-foreground">All Milestone Rewards</span>
          </div>`,
      description: `<div class="space-y-3">
          <p class="text-sm text-muted-foreground">View all available reward tiers and what you can win at each level. This is your complete roadmap to success!</p>
          <div class="bg-brand-50 p-3 rounded-lg">
            <ul class="text-xs text-brand-800 space-y-1">
              <li>• See all available reward tiers from start to finish</li>
              <li>• <strong>Highlighted tier:</strong> Your current achievement level</li>
              <li>• <strong>Completed tiers:</strong> Marked with a star icon</li>
              <li>• <strong>Locked tiers:</strong> Future milestones to unlock</li>
              <li>• Each tier shows revenue threshold and rewards</li>
              <li>• Plan your journey to the top!</li>
            </ul>
          </div>
        </div>`,
      side: "left" as const,
      align: "start" as const,
    },
  },
  {
    element: "#RL-next-reward-info",
    popover: {
      title: `<div class="flex items-center gap-3 mb-3">
            <div class="w-8 h-8 bg-brand-100 rounded-full flex items-center justify-center">
              <svg class="w-4 h-4 text-brand-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 10V3L4 14h7v7l9-11h-7z"></path>
              </svg>
            </div>
            <span class="text-base font-semibold text-foreground">Next Reward Preview</span>
          </div>`,
      description: `<div class="space-y-3">
          <p class="text-sm text-muted-foreground">Stay motivated by seeing exactly what you'll unlock next! This card shows the rewards waiting for you at the next tier.</p>
          <div class="bg-brand-50 p-3 rounded-lg">
            <ul class="text-xs text-brand-800 space-y-1">
              <li>• Shows amount remaining to next milestone</li>
              <li>• Lists all rewards you'll unlock</li>
              <li>• Appears at the bottom of the sidebar</li>
              <li>• Updates as you progress</li>
              <li>• Keep pushing towards your goal!</li>
            </ul>
          </div>
        </div>`,
      side: "left" as const,
      align: "end" as const,
    },
  },
];
